const hitsReducer = (state = 0, action) => {
    switch(action.type) {
        case 'CHANGE_HITS':
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export default hitsReducer;